function HelpDesk() {
    "use strict";

    /**
     *
     * @param threadKey
     */
    this.deleteThread = (threadKey) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'deleteThread',
                threadKey: threadKey,
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) {
                    $('article[data-key='+threadKey+']').remove();
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    /**
     *
     * @param threadKey
     */
    this.followThread = (threadKey) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'followThread',
                threadKey: threadKey,
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) {
                    $('article[data-key='+threadKey+']').find('a.follow').removeClass('off').addClass('on');
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    this.updateCategoriesOrder = () => {
        let catList = $.map($('#categories article'), function(el) {
            return $(el).attr('data-categoryid');
        });
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'updateOrder',
                catList: catList,
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) {
                    return true;
                }
            })
            .catch(function(err) {
                console.warn(err);
            });

    };





    this.deleteImage = (catID) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'deleteImage',
                catID: catID,
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) {
                    window.location.reload(true);
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    this.uploadImage = (el) => {
        let fileParts = el.val().split('\\');
        let fileName = fileParts[fileParts.length - 1];
        let parts = fileName.split('.');
        let extension = parts[parts.length-1];
        if(extension!=='png' && extension!=='jpg' && extension!=='PNG' && extension!=='JPG') {
            window.alert('You can only upload PNGs or JPGs');
            el.val('');
        }

        let file = el.get(0).files[0];

        let article = el.closest('article');
        let xhr = new XMLHttpRequest();
        xhr.onload = (evt) => {
            let status = null;
            try {
                status = evt.target.status;
            }
            catch(e) {
                return;
            }
            if(status === 200 && evt.target.responseText) {
                let p = JSON.parse(evt.target.responseText);
                window.checkResponse(p);
                if(p!==false) {
                    window.location.reload(true);
                }
            }
        };

        xhr.addEventListener('load',this.imgReadyStateHandler,false);
        xhr.open('POST', '/forum/ajax_forumImages.php?vAction=uploadImage', true);
        xhr.setRequestHeader("X-FileName", file.name);
        xhr.setRequestHeader("X-CategoryID", article.attr('data-categoryid'));
        xhr.setRequestHeader("Content-Type", "application/octet-stream");
        xhr.send(file);
    };



    this.imgReadyStateHandler = (evt) =>  {
        let status = null;
        try {
            status = evt.target.status;
        }
        catch(e) {
            return;
        }
        if (status == '200' && evt.target.responseText) {
            console.log('ey what now?');
            //var p = JSON.parse(evt.target.responseText);
            //console.log(p.invoiceKey);
        }
    };


    this.renameThread = () => {
        let originalTitleElement = $('#threadSpan');
        let h1 = $('div.thread h1');
        let originalButton = h1.find('button');
        originalTitleElement.hide(); originalButton.hide();
        let newInput = $('<input>', {type:'text', name:'renamedThread', id: 'renamedThread', 'class':'rename'}).val(originalTitleElement.text());
        let newSave = $('<button>', {type:'button', 'class':'renameSave'}).text('Save');
        let newCancel = $('<button>', {type:'button', 'class':'cancelSave'}).text('Cancel');
        h1.append(newInput, newSave, newCancel);
    };


    this.cancelThreadEdit = () => {
        let thread = $('div.thread').first();
        thread.find('.renameSave, .cancelSave, #renamedThread').remove();
        thread.find('#threadSpan, .renameButton').show();
    };


    this.saveThreadName = () => {
        let threadInput = $('#renamedThread');
        if(threadInput.length > 0 && $.trim(threadInput.val())!=='') {
            fetch('/fetch/fetch_forums.php', {
                method: 'post',
                credentials: 'include',
                body: JSON.stringify({
                    action: 'renameThread',
                    threadID: $('#discussion').attr('data-threadid'),
                    title: threadInput.val()
                })
            })
                .then(window.fetchStatusCheck)
                .then(window.jsonize)
                .then(data => {
                    if(window.checkResponse(data)) { //hard reload for now, not interested in a great Admin UI experience, just bang this out
                        window.location.reload(true);
                    }
                })
                .catch(function(err) {
                    console.warn(err);
                });
        }
    };


    this.moveThread = () => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'moveThread',
                threadID: $('#discussion').attr('data-threadid'),
                catID: $('#threadMover').val()
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) { //hard reload for now, not interested in a great Admin UI experience, just bang this out
                    window.location.reload(true);
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    /**
     *
     * @param ev
     * @returns {boolean}
     */
    this.preflightQuestion = (ev) => {

        let form  = $('#questionForm');
        let errorMessages = [];
        if(form.find('select.questionCategory').first().val()==='') {
            errorMessages.push('Please select a category for your question');
        }
        if(form.find('input.questionTitle').first().val()==='') {
            errorMessages.push('Please provide a general title for your question');
        }
        if(form.find('.question').first().val()==='') {
            errorMessages.push('Please submit a question');
        }

        if($('body').hasClass('streetUser')) {
            if(!this.checkStreetComment()) {
                ev.preventDefault();
                window.alert('Please fill out all the required fields');
                return;
            }
        }

        if(errorMessages.length !== 0) {
            let errorMsg = errorMessages.join("\r\n");
            window.alert(errorMsg);
            ev.preventDefault();
            return false;
        }
        else {
            form.off();
            form.submit();
        }
    };


    this.checkStreetComment = () => {
        let form = $('form.helpDeskSubmission').first();
        let requiredFields = form.find('li.required input, li.required select');
        let passThrough = true;

        if($('textarea.newComment').val().trim()==='') {
            passThrough = false;
        }

        requiredFields.each((i, el) => {
            el = $(el);
            if(!(el).hasClass('excludeRequired') && $.trim(el.val())==='') {
                passThrough = false;
                el.closest('li').addClass('missingValue');
            }
        });

        return passThrough;
    };



    this.postComment = () => {

        let form = $('div.yourComments').find('form').first();
        if(form.attr('action')==='/helpDesk/_streetComment.php') {
            if(this.checkStreetComment()) {
                form.off();
                form.submit();
                return;
            }
            else {
                window.alert('Please fill out all the required fields');
                return;
            }
        }

        let section = $('#discussion');
        let comment = section.find('textarea.newComment').val();

        if($.trim(comment)==="") {
            window.alert('Please provide a comment');
        }
        else {
            $('#commentForm').submit();
        }

    };


    this.anonymizeUser = (action, threadID, userID) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: action,
                threadID: threadID,
                userID: userID
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) { //hard reload for now, not interested in a great Admin UI experience, just bang this out
                    window.location.reload(true);
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    this.deletePost = (threadID, postKey) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'deletePost',
                postKey: postKey,
                threadID: threadID
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) { //hard reload for now, not interested in a great Admin UI experience, just bang this out
                    window.location.reload(true);
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    this.editPost = (action, threadID, postKey) => {
        let extraClass = action==='resume' ? 'resume' : '';
        let saveText = action==='resume' ? 'Publish Comment' : 'Save Edit';
        let postArticle = $('article[data-key="'+postKey+'"]');
        let originalPost = postArticle.find('p');
        let adminControls = postArticle.find('div.adminControls');
        let header = postArticle.find('header');
        let textArea = $('<textarea>',{'class':'midEdit editingPost '+extraClass,value:originalPost.text()}).text(originalPost.text());
        let cancelButton = $('<button>', {type:'button', 'class':'midEdit cancelEdit'}).text('Cancel Edit');
        let saveButton = $('<button>', {type:'button', 'class':'midEdit saveEdit'}).text(saveText);
        adminControls.find('button').hide();
        originalPost.hide();
        textArea.insertAfter(header);
        adminControls.append(cancelButton, saveButton);
    };


    this.cancelPostEdit = (threadID, postKey) => {
        let postArticle = $('article[data-key="'+postKey+'"]');
        let originalPost = postArticle.find('p');
        let adminControls = postArticle.find('div.adminControls');
        postArticle.find('.midEdit').remove();
        originalPost.show();
        adminControls.find('button').show();
    };


    this.savePostEdit = (threadID, postKey) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'saveEdit',
                postKey: postKey,
                threadID: threadID,
                comment: $('textarea.editingPost').val()
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) { //hard reload for now, not interested in a great Admin UI experience, just bang this out
                    window.location.reload(true);
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };


    this.saveComment = (threadID) => {
        fetch('/fetch/fetch_forums.php', {
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                action: 'saveComment',
                threadID: threadID,
                comment: $('textarea.newComment').val()
            })
        })
            .then(window.fetchStatusCheck)
            .then(window.jsonize)
            .then(data => {
                if(window.checkResponse(data)) { //hard reload for now, not interested in a great Admin UI experience, just bang this out
                    window.location.reload(true);
                }
            })
            .catch(function(err) {
                console.warn(err);
            });
    };



    /**
     *
     */
    this.init = function init() {
        $('button.deleteThread').on('click', ev => {
            if(window.confirm('Really delete this thread?')) {
                let threadKey = $(ev.target).closest('article').attr('data-key');
                this.deleteThread(threadKey);
            }
        });

        $('body.streetUser a.follow').on('click', ev => {
            ev.preventDefault();
            if(window.confirm('To follow a thread, you need an account. Would you like to register for an account now?')) {
                window.location.href = '/xmFront/signIn.php?signUp';
            }
        });

        $('body.adminView a.follow').on('click', ev => {
            ev.preventDefault();
            console.log('u admin');
        });

        $('body.userView a.follow').on('click', ev => {
            ev.preventDefault();
            if(window.confirm('Following a thread means that you will receive an email whenever there is a new post.\nDo you want to follow this thread?')) {
                let threadKey = $(ev.target).closest('article').attr('data-key');
                this.followThread(threadKey);
            }
        });

        $('button.imageDeleter').on('click', ev => {
            let catID = $(ev.target).closest('article').attr('data-categoryid');
            if(window.confirm('Really delete this image?')) {
                this.deleteImage(catID);
            }
        });

        let categories = $('#categories');
        if(categories.length > 0 && $('body').hasClass('adminView')) {
            categories.sortable({
                handle: 'header',
                axis: 'y',
                update: () => {
                    this.updateCategoriesOrder();
                }
            });
        }

        $('input.imgUpload').on('change', ev => {
            let el = $(ev.target);
            this.uploadImage(el);
        });


        let thread = $('#discussion div.thread');
        if(thread.length > 0) {
            thread.on('click', 'button', (ev) => {
                let el = $(ev.target);
                if(el.hasClass('renameButton')) {
                    this.renameThread();
                }
                if(el.hasClass('renameSave')) {
                    if(window.confirm('Really save this thread title?')) {
                        this.saveThreadName();
                    }
                }
                if(el.hasClass('cancelSave')) {
                    this.cancelThreadEdit();
                }
            });
        }

        $('#threadMover').on('change', () => {
            if(window.confirm('Really move this thread to another category?')) {
                this.moveThread();
            }
        });

        $('#questionForm').on('submit', (ev) => {
            this.preflightQuestion(ev);
        });

        $('form.helpDeskSubmission').on('change', 'input, select', function(e) {
            let el = $(this);
            if($.trim(el.val())!=='') {
                el.closest('li').removeClass('missingValue');
            }
            if(el.hasClass('newItem') && $.trim(el.val())==='') {
                el.closest('li').find('select').val('');
                el.hide();
            }
        });



        $('button.postComment').on('click', () => {
            this.postComment();
        });

        thread.on('click', 'input.anonymize', (ev) => {
            let el = $(ev.target);
            let threadID = el.closest('section').attr('data-threadid');
            let userID = el.closest('article').attr('data-userid');
            if(window.confirm('Really anonymize this user?')) {
                this.anonymizeUser('anonymize',threadID, userID);
            }
            else {
                el.prop('checked', false);
            }
        });

        thread.on('click', 'input.deAnonymize', (ev) => {
            let el = $(ev.target);
            let threadID = el.closest('section').attr('data-threadid');
            let userID = el.closest('article').attr('data-userid');
            if(window.confirm('Remove anonymity for this user?')) {
                this.anonymizeUser('deAnonymize',threadID, userID);
            }
            else {
                el.prop('checked', false);
            }
        });

        thread.on('click', 'button.deletePost', (ev) => {
            let el = $(ev.target);
            let postID = el.closest('article').attr('data-key');
            let threadID = el.closest('section').attr('data-threadid');
            if(window.confirm('Really delete this post?')) {
                this.deletePost(threadID, postID);
            }
        });


        thread.on('click', 'button.editPost, button.resumePost', (ev) => {
            let el = $(ev.target);
            let postID = el.closest('article').attr('data-key');
            let threadID = el.closest('section').attr('data-threadid');
            let action = el.hasClass('editPost') ? 'edit' : 'resume';
            this.editPost(action,threadID, postID);
        });

        thread.on('click', 'button.cancelEdit', (ev) => {
            let el = $(ev.target);
            let postID = el.closest('article').attr('data-key');
            let threadID = el.closest('section').attr('data-threadid');
            this.cancelPostEdit(threadID, postID);
        });

        thread.on('click', 'button.saveEdit', (ev) => {
            if(window.confirm('Really save this edit?')) {
                let el = $(ev.target);
                let postID = el.closest('article').attr('data-key');
                let threadID = el.closest('section').attr('data-threadid');
                this.savePostEdit(threadID, postID);
            }
        });

        thread.on('click', 'button.saveComment', (ev) => {
            if(window.confirm('Save your comment and publish your response another time?')) {
                let el = $(ev.target);
                let threadID = el.closest('section').attr('data-threadid');
                this.saveComment(threadID);
            }
        });

        $('#questionFile').on('change', (ev) => {
            let el = $(ev.target);
            let extension = el.val().split('.').pop();
            if(extension.toLowerCase()!=='jpg' && extension.toLowerCase()!=='pdf') {
                window.alert('We only accept PDF or JPG files for upload');
                el.val('');
            }
        });

        $('button.socialPost').on('click', (ev) => {
            let url = `${window.location.href}&socialPost=post`;
            window.location.href = url;
        });



    }; //end init


    this.init();


}
